import { legacy_createStore as createStore } from "redux";
import { cartReducer } from "./cart/reducer";

export const store = createStore(cartReducer);